import React, { useEffect, useRef } from "react";
import { toast } from "react-toastify";
import { apiPost, apiPut } from "../../Utils/apiFetch";
import apiPath from "../../Utils/apiPath";
import { Form } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { t } from "i18next";
import { isEmpty, set } from "lodash";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import OtpValidation from "./OtpValidation";
const AddProfile = ({ select, setSelect, profileData, getProfileData }) => {
  const {
    register,
    handleSubmit,
    control,
    watch,
    setValue,
    formState: { errors, touchedFields },
  } = useForm();
  const inputRef = useRef(null);
  const [otpSent, setOtpSent] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [oldPhone, setOldPhone] = React.useState("");
  const onSubmit = async (body) => {
    setLoading(true);
    if (select?.type === "phone" && select?.statusPhone == false) {
      const { status, data } = await apiPost(apiPath.userSendOtp, {
        phone_number: body?.mobile,
      });

      if (data.success) {
        toast.success("OTP sent succesfully");

        setOtpSent(true);
      } else {
        toast.error(data?.message);
      }
    } else if (select?.type === "phone" && select?.statusPhone) {
      const { status, data } = await apiPost(apiPath.userSendOtp, {
        phone_number: profileData?.phone,
      });

      if (data.success) {
        toast.success("OTP sent succesfully");
        setOldPhone(body?.mobile);
        setOtpSent(true);
      } else {
        toast.error(data?.message);
      }
    } else {
      const { status, data: response_users1 } = await apiPost(
        apiPath.userProfileUpdate,
        select?.type == "birthday"
          ? { dob: body?.dob }
          : select?.type == "fullname"
            ? {
                fullName: body?.username,
              }
            : { email: body?.email },
      );
      if (status === 200) {
        if (response_users1.success) {
          toast.success(response_users1?.message);
          setSelect({});
          getProfileData();
          setLoading(false);
        } else {
          toast.error(response_users1?.message);
          setLoading(false);
        }
      } else {
        toast.error(response_users1?.message);
        setLoading(false);
      }
    }

    setLoading(false);
  };
  const today = new Date().toISOString().split("T")[0];
  useEffect(() => {
    if (select?.title == "Verfiy Phone Number") {
      setValue("mobile", select?.phone);
    }
  }, [select]);

  return (
    <div
      _ngcontent-serverapp-c1375071257
      className="content mcd-style new-profile third-party-login member-content"
    >
      <router-outlet _ngcontent-serverapp-c1375071257 name="popup" />
      <ng-component className="ng-star-inserted">
        <router-outlet />
        <ng-component
          _nghost-serverapp-c3998425339
          className="ng-star-inserted"
        >
          {select?.type === "phone" && otpSent ? (
            <ng-component
              _nghost-serverapp-c1586222475
              className="ng-star-inserted"
            >
              <mcd-verify-code-inner
                _ngcontent-serverapp-c1586222475
                _nghost-serverapp-c1135157547
              >
                <div
                  _ngcontent-serverapp-c1135157547
                  className="verification-wrap ng-star-inserted"
                >
                  <div
                    _ngcontent-serverapp-c1135157547
                    className="verification-txt"
                  >
                    <p _ngcontent-serverapp-c1135157547>
                      {" "}
                      Please enter the 4-digit code sent to{" "}
                      <span
                        _ngcontent-serverapp-c1135157547
                        className="player ng-star-inserted"
                      >
                        +{select?.phone}
                      </span>
                    </p>
                  </div>
                  <div
                    _ngcontent-serverapp-c1135157547
                    className="verification-content"
                  >
                    <OtpValidation
                      setSelect={setSelect}
                      oldPhone={oldPhone}
                      select={select}
                    />
                  </div>
                  <div
                    _ngcontent-serverapp-c1135157547
                    className="verification-tips"
                  >
                    <p _ngcontent-serverapp-c1135157547>
                      {" "}
                      Didn't receive code?{" "}
                      <a
                        _ngcontent-serverapp-c1135157547
                        className="resend-btn active disabled"
                      >
                        {" "}
                        Resend{" "}
                        {/* <span
                          _ngcontent-serverapp-c1135157547
                          className="time active"
                        >
                          (29:46)
                        </span> */}
                      </a>
                    </p>
                  </div>
                </div>
                <div
                  _ngcontent-serverapp-c1135157547
                  className="pop-wrap pop-success ng-star-inserted"
                >
                  <div
                    _ngcontent-serverapp-c1135157547
                    className="register-success-wrap"
                  >
                    <div
                      _ngcontent-serverapp-c1135157547
                      className="register-success-cont"
                    >
                      <div
                        _ngcontent-serverapp-c1135157547
                        className="register-success-txt top-inner"
                      >
                        <div
                          _ngcontent-serverapp-c1135157547
                          className="success-checkmark"
                        >
                          <div
                            _ngcontent-serverapp-c1135157547
                            className="check-icon"
                          >
                            <span
                              _ngcontent-serverapp-c1135157547
                              className="icon-line line-tip"
                            />
                            <span
                              _ngcontent-serverapp-c1135157547
                              className="icon-line line-long"
                            />
                            <div
                              _ngcontent-serverapp-c1135157547
                              className="icon-circle"
                            />
                            <div
                              _ngcontent-serverapp-c1135157547
                              className="icon-fix"
                            />
                          </div>
                        </div>
                        <h4 _ngcontent-serverapp-c1135157547> Success</h4>
                      </div>
                    </div>
                  </div>
                </div>
              </mcd-verify-code-inner>
              <mcd-profile-verified-success-inner
                _ngcontent-serverapp-c1586222475
                _nghost-serverapp-c961502802
                className="ng-tns-c961502802-13 ng-star-inserted"
              ></mcd-profile-verified-success-inner>
            </ng-component>
          ) : (
            <div
              _ngcontent-serverapp-c3998425339
              className="content player-content ng-star-inserted"
            >
              <Form
                _ngcontent-serverapp-c3998425339
                onSubmit={handleSubmit(onSubmit)}
                className="ng-untouched ng-pristine ng-invalid"
              >
                <div _ngcontent-serverapp-c3998425339 className="menu-box">
                  <div _ngcontent-serverapp-c3998425339 className="input-group">
                    <label _ngcontent-serverapp-c3998425339>
                      {select?.label}
                    </label>
                    {select?.type === "phone" &&
                    select?.statusPhone == false ? (
                      <div
                        _ngcontent-serverapp-c3998425339
                        className="input-wrap phone-wrap btn-disabled ng-star-inserted"
                      >
                        <div
                          _ngcontent-serverapp-c3998425339
                          className="phone-area-code"
                        >
                          <div
                            _ngcontent-serverapp-c3998425339
                            className="lang-select"
                          >
                            <button
                              _ngcontent-serverapp-c3998425339
                              className="btn-select only"
                            >
                              <li _ngcontent-serverapp-c3998425339>
                                <img
                                  _ngcontent-serverapp-c3998425339
                                  value="BD"
                                  alt="BD"
                                  src="https://img.b426b.com/bb/h5/assets/images/flag/BD.png?v=1777968966408"
                                  loading="lazy"
                                />
                                <span _ngcontent-serverapp-c3998425339>
                                  +880
                                </span>
                              </li>
                            </button>
                          </div>
                        </div>
                        <input
                          _ngcontent-serverapp-c3998425339
                          type="text"
                          inputMode="tel"
                          className="input ng-untouched ng-pristine"
                          placeholder="Enter your phone number."
                          disabled
                          {...register("mobile")}
                        />
                      </div>
                    ) : select?.type === "phone" && select?.statusPhone ? (
                      <div className="input-wrap phone-wrap">
                        <Controller
                          control={control}
                          name="mobile"
                          rules={{
                            required: t("Enter_Mobile"),
                            validate: (value) => {
                              let inputValue = value
                                ?.toString()
                                ?.slice(
                                  inputRef?.current?.state?.selectedCountry
                                    ?.countryCode?.length,
                                  value?.length,
                                );
                              if (inputValue?.length < 10) {
                                return t("MobileMin");
                              } else if (inputValue?.length > 12) {
                                return t("MobileMax");
                              } else {
                                return true;
                              }
                            },
                          }}
                          render={({ field: { ref, ...field } }) => (
                            <>
                              <PhoneInput
                                {...field}
                                inputExtraProps={{
                                  ref,
                                  required: true,
                                  autoFocus: true,
                                }}
                                ref={inputRef}
                                className="inputrefNew"
                                country={"bd"}
                              />
                            </>
                          )}
                        />
                      </div>
                    ) : (
                      <input
                        _ngcontent-serverapp-c3998425339
                        type={select?.type == "birthday" ? "date" : "text"}
                        className="input ng-untouched ng-pristine ng-invalid ng-star-inserted"
                        placeholder={select?.placeholder}
                        {...register(
                          select?.type === "birthday"
                            ? "dob"
                            : select?.type === "fullname"
                              ? "username"
                              : "email",
                          select?.type === "birthday"
                            ? {
                                required: "Date of birth is required",
                                validate: (v) =>
                                  v <= today || "Date must be in the past",
                              }
                            : select?.type === "fullname"
                              ? {
                                  required: t("Enter_Valid_Username"),
                                  validate: {
                                    noLeadingSpaces: (value) =>
                                      !/^\s/.test(value) ||
                                      t("Enter_Valid_Username"),
                                    noTrailingSpaces: (value) =>
                                      !/\s$/.test(value) ||
                                      t("Enter_Valid_Username"),
                                    alphanumericOnly: (value) =>
                                      /^[a-zA-Z0-9 ]*$/.test(value) ||
                                      t("Only_Alphabets_And_Numbers_Allowed"),
                                    noOnlySpaces: (value) =>
                                      value.trim().length > 0 ||
                                      t("Enter_Valid_Username"),
                                    mustContainAlphabet: (value) =>
                                      /[a-zA-Z]/.test(value) ||
                                      t(
                                        "Username_Must_Contain_At_Least_One_Letter",
                                      ),
                                    minLength: (value) =>
                                      value.trim().length >= 3 || t("Min3User"),
                                    maxLength: (value) =>
                                      value.trim().length <= 30 ||
                                      t("Max30User"),
                                  },
                                }
                              : {
                                  required: t("Pleaseenteremail"),
                                  pattern: {
                                    value:
                                      /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                    message: t("Invalidemailaddress"),
                                  },
                                },
                        )}
                      />
                    )}
                    {!isEmpty(errors?.email?.message) && (
                      <div class="alert ">{errors?.email?.message}</div>
                    )}
                    {!isEmpty(errors?.username?.message) && (
                      <div class="alert ">{errors?.username?.message}</div>
                    )}
                    {!isEmpty(errors?.dob?.message) && (
                      <div class="alert ">{errors?.dob?.message}</div>
                    )}
                  </div>
                </div>{" "}
                <button
                  disabled={loading}
                  className="button btn-primary app-style"
                  style={{
                    border: "none",
                    color: "white",
                    fontSize: "15px",
                    fontWeight: "600",
                    width: "stretch",
                  }}
                  type="submit"
                >
                  {loading ? (
                    <div
                      _ngcontent-serverapp-c381631582=""
                      class="btn-loading"
                    ></div>
                  ) : select?.type === "phone" &&
                    select?.statusPhone == false ? (
                    "Send Verification Code"
                  ) : (
                    t("Submit")
                  )}
                </button>
              </Form>

              <p
                _ngcontent-serverapp-c3998425339
                className="button-tips player"
              >
                For your privacy, the information cannot be modified after
                confirmation.If you need help, please contact{" "}
                <i>Customer Service.</i>
              </p>
            </div>
          )}
        </ng-component>
      </ng-component>
    </div>
  );
};

export default AddProfile;
